import { MainLayout } from '../components';
import { Routes, Route } from 'react-router-dom';
import ReportPage from './reports/ReportPage';
import DirectoryWrapper from './directories/DirectoryWrapper';
import NationalHelplineWrapper from './directories/NationalHelplineWrapper';
import ResourcesPage from './resources/ResourcesPage';
import TagsPage from './tags/TagsPage';
import ContentExportPage from './content-export/ContentExport';
import { useContext } from 'react';
import { AppContext } from '../context/app-context';

 
const AppRoutes = () => {
  const { selectedCountry, profile } = useContext(AppContext);

  const UKDisclaimer = () => {
    return (
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "80%"
      }}>
        <h1>
          {"Service Directory & Tags for the UK cannot be managed via this portal."}
        </h1>
      </div>
    );
  };

  const ukSelected = profile?.Market === "UK" || selectedCountry?.code.iv === "UK";

  return (
    <>
      <MainLayout>
        <Routes>
          <Route path="/" Component={ReportPage} />
          <Route path="content-export" Component={ContentExportPage} />
          {/* Block/redirect UK from viewing/editing service directory, as their locations are archived per One Directory project */}
          <Route path="service-directory" Component={ukSelected ? UKDisclaimer : DirectoryWrapper} />
          <Route path="national-helplines" Component={ukSelected ? UKDisclaimer : NationalHelplineWrapper} />
          <Route path="filters" Component={ukSelected ? UKDisclaimer : TagsPage} />
          <Route path="resources" Component={ResourcesPage} />
        </Routes>
      </MainLayout>
    </>
  );
};

export default AppRoutes;
